











import Vue from 'vue'
import Component from 'vue-class-component'
import BaseIcon from '@app/componentlib/src/views/components/BaseIcon.vue'
import Heart from '@app/componentlib/src/views/components/icons/Heart.vue'
import HeartBorder from '@app/componentlib/src/views/components/icons/HeartBorder.vue'

@Component<HeartEmptyFull>({
  props: {
    isFull: Boolean
  },
  components: {
    BaseIcon,
    Heart,
    HeartBorder
  }
})

export default class HeartEmptyFull extends Vue {
  /**
   * Props variables
   */
  isFull: boolean = false

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */
  heartClicked(event: any) {
    event.preventDefault()
    event.stopPropagation()
    this.$emit('heartClicked')
  }
}
